/**
 * DetailHeroSideColumnContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Container for the detail hero side column.
 */
const DetailHeroSideContainer = styled.div<React.CSSProperties>`
  display: flex;
  position: relative;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  left: ${24 * Screen.widthRatio}px;
`;

export default DetailHeroSideContainer;
